// utilsResource.jsx
// Utility functions for Resource operations

// Add a new Resource
export function addResource(dsd, Data, onAdd, onError) {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadResource(Data);

    dsd.httpConfig.post(`/resources`, payload, headers)
        .then(response => {
            if (onAdd) {
                onAdd(response.data.id);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.log(e);
        });

    return;
}

// Edit an existing Resource
export function editResource(dsd, id, Data, onUpdate, onError) {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadResource(Data);

    dsd.httpConfig.put(`/resources/${id}`, payload, headers)
        .then(response => {
            if (onUpdate) {
                onUpdate();
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.log(e);
        });

    return;
}

// Create payload for Resource
export function payloadResource(data) {
    let payload = {};
    payload.name = data.name;
    payload.description = data.description;
    payload.proposals = data.proposals;
    payload.type = data.type;
    payload.URL = data.URL;
    payload.status = data.status;

    return payload;
}

// Process Resource data
export function dataResource(data) {
    let Resource = data;
    return Resource;
}

// Get a single Resource
export const getResource = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/resources/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

// List Resources with optional filters
export function listResources(dsd, Filters = {}, onLoad, onError) {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/resources";
    if (Object.keys(Filters).length > 0) {
        urlAPI += "?";
    }

    if (Filters.idUser) {
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.status) {
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.idProcess) {
        urlAPI += `idProcess=${encodeURIComponent(Filters.idProcess)}&`;
    }

    if (Filters.idArtefact) {
        urlAPI += `idArtefact=${encodeURIComponent(Filters.idArtefact)}&`;
    }

    if (Filters.scope) {
        urlAPI += `scope=${encodeURIComponent(Filters.scope)}&`;
    }

    if (Filters.search) {
        urlAPI += `search=${encodeURIComponent(Filters.search)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arrResources = [];
            for (let pos = 0; pos < response.data.length; pos++) {
                arrResources.push(dataResource(response.data[pos]));
            }

            if (onLoad) {
                onLoad(arrResources);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.log(e);
        });

    return;
}
